import SafeRenderHtml from 'CampaignVolunteer/components/SafeRenderHtml'
import './DashboardInstructions.scoped.scss'

export default function DashboardInstructions() {
  const instructions = useSel(s => s.dashboard.instructions)

  const [instructionsExpanded, setInstructionsExpanded] = useState(false)
  const [hideInstructions, setHideInstructions] = useState(false)

  return hideInstructions ? <></> : <div className="instructions">
        <div className="instructions-header">
          <div className="icon"><SvgIconsTipInGreyBox /></div>
          <div className="instructions-title">
            <h1 className="no-margin">Need help?</h1>
            <p className="no-margin-bottom margin-top half">For an explanation of this page and help using it, please read the instructions here.</p>
          </div>
          {!instructionsExpanded && 
            <button className="button primary small margin-right help-button" onClick={() => setInstructionsExpanded(!instructionsExpanded)}>
              See instructions
            </button>
          }
          <div className="close-button" onClick={() => setHideInstructions(true)}>
            <SvgIconsClose />
          </div>
        </div>
        {instructionsExpanded && 
          <div className="instructions-body">
            <div className="content">
              <SafeRenderHtml html={instructions} />
            </div>
          </div>
        }
    </div>
}
